import * as JumpLinks from './js-apps/jump-links'
import * as AutoAnchorNav from './js-apps/auto-anchor-nav'
import * as AnchorToc from './js-apps/anchor-toc'
import * as Footer from './js-apps/footer'
import * as AdsSlash from './js-apps/ads-slash'
import AOS from 'simple-aos'; //this is animate on scroll
import * as BlogLanding from './js-apps/blog-landing'
import * as Nav from './js-apps/nav'
import * as HomeIntro from './js-apps/home-intro'
import * as HeroSelector from './js-apps/hero-selector'
import * as ContentTabs from './js-apps/content-tabs'
import * as FAQ from './js-apps/faq'
import * as ReportNavigation from './js-apps/report-navigation'
import * as GlobalNotifications from './js-apps/global-notifications'
import * as Carousel from './js-apps/carousel'
import * as ContentCTAGrid from './js-apps/content-cta-grid'
import * as ImageRowSlider from './js-apps/image-row-slider'
import * as ShortCodeVideos from './js-apps/short-code-videos'
import * as IamaSelectBox from './js-apps/iama-selectbox'
import * as PromoSlider from './js-apps/promo-slider'
import * as TabbedTable from './js-apps/tabbed-table'
import * as ReasonAccordion from './js-apps/reason-accordion'
import * as ShowMore from './js-apps/show-more'
import * as SiteContext from './js-apps/site-context'
import * as NdsNav from './js-apps/nds-nav'
import * as DrainageInstructions from './js-apps/drainage-instructions'
import * as DrainageProblemPins from './js-apps/drainage-problem-pins'
import * as DrainageCapacity from './js-apps/drainage-capacity'
import * as DrainageHotspotDebug from './js-apps/drainage-hotspot-debug'
import * as NdsProductModels from './js-apps/nds-product-models'

//modules that need initialization after dom ready or personalization ready for Sitefinity
function initAllAfterReady(){
    ShowMore.init();
    JumpLinks.init();
    AutoAnchorNav.init();
    AnchorToc.init();
    Footer.init();
    BlogLanding.init();
    Nav.init();
    HomeIntro.init();
    HeroSelector.init();
    ContentTabs.init();
    FAQ.init();
    ReportNavigation.init();
    Carousel.init();
    ContentCTAGrid.init();
    ImageRowSlider.init();
    ShortCodeVideos.init();
    IamaSelectBox.init();
    PromoSlider.init();
    TabbedTable.init();
    ReasonAccordion.init();
    NdsNav.init();
    DrainageInstructions.init();
    DrainageProblemPins.init();
    DrainageCapacity.init();
    DrainageHotspotDebug.init();
    NdsProductModels.init();
    
}

//modules that need to be initalized ASAP and only depend on HTML parsing completion
//these can load when the HTML is ready, but perhaps before images, fonts, etc are completed
//and don't depend on being personalized by Sitefinity
function initAllOnLoad(){
    SiteContext.init();
    AdsSlash.init();
    AOS.init();
    GlobalNotifications.init();
}

export { initAllAfterReady, initAllOnLoad };